export default __webpack_public_path__ + "static/media/mat.5d35ee64.png";